import { setLocalStorage } from '@/tool/localStore';
// 获取基地
export const GET_BASE = 'get_base';

// 用药单位
export const UNIT_LIST = {
  code: '0',
  data: [
    { key: 'g', value: 'g' },
    { key: 'mg', value: 'mg' },
    { key: 'µg', value: 'µg' },
    { key: 'ml', value: 'ml' },
    { key: 'ppm', value: 'ppm' },
  ],
  success: true,
};

// 检验类型 Inspection type
export const INSPECTION_TYPE = [
  { key: '生长检验', value: 'growth' },
  { key: '健康检验', value: 'health' },
  { key: '第三方检疫', value: 'inspection' },
  // { key: '镜检', value: 'microscopic' },
];
// 所有检测类型 以下字段顺序请勿随意变更！🈲🈲🈲🈲，如有需求请联系 coderLi
export const PRPOR_TYPE_COLUMNS = [
  {
    label: '水质监测',
    ai: 'waterRequest',
    value: 'waterRequest',
    alias: 'water',
    disabled: false,
    excludeFields: ['uploadFiles', 'waterResult'],
  },
  {
    label: '损耗记录',
    ai: 'lossRequest',
    value: 'lossRequest',
    alias: 'loss',
    disabled: false,
    excludeFields: ['uploadFiles'],
  },
  {
    label: '饵料投喂',
    ai: 'feedingRequest',
    value: 'feedingRequest',
    alias: 'feeding',
    disabled: false,
    excludeFields: ['uploadFiles'],
  },
  // {
  //   label: '动保记录旧',
  //   ai: 'medicationRequest',
  //   value: 'medicationRequest',
  //   alias: 'medication',
  //   disabled: false,
  //   excludeFields: ['details', 'uploadFiles'],
  // },
  // {
  //   label: '动保记录',
  //   ai: 'aquaMedication',
  //   value: 'aquaMedication',
  //   alias: 'medication',
  //   disabled: false,
  //   excludeFields: ['details', 'uploadFiles'],
  // },
  {
    label: '环控记录',
    value: 'environmentRecordRequest',
    _ref: '',
    alias: 'environment',
    ai: 'environment',
    disabled: false,
    excludeFields: ['remark', 'uploadFiles'],
  },
  // {
  //   label: '检验记录',
  //   value: 'examiningReportRequest',
  //   alias: 'examining',
  //   disabled: false,
  //   exclude: true,
  // },
  {
    label: '三方检疫',
    ai: 'inspectionReportRequest',
    value: 'inspectionReportRequest',
    alias: 'inspection',
    disabled: false,
    excludeFields: ['remark', 'uploadFiles'],
  },
  {
    label: '健康情况',
    ai: 'healthRecordRequest',
    value: 'healthRecordRequest',
    alias: 'health',
    disabled: false,
    excludeFields: ['remark', 'uploadFiles'],
  },
  {
    label: '生长情况',
    ai: 'growthSituationRequest',
    value: 'growthSituationRequest',
    alias: 'growth',
    disabled: false,
    excludeFields: ['remark', 'uploadFiles'],
  },
  // {
  //   label: '流通暂养',
  //   ai: 'temporaryCareRequest',
  //   value: 'temporaryCareRequest',
  //   alias: 'temporaryCare',
  //   disabled: false,
  //   excludeFields: ['remark', 'uploadFiles'],
  // },
  // {
  //   label: '调水',
  //   ai: 'waterResponseRequest',
  //   value: 'waterResponseRequest',
  //   alias: 'waterResponse',
  //   disabled: false,
  //   excludeFields: ['remark', 'uploadFiles'],
  // },
  // {
  //   label: '镜检',
  //   ai: 'microscopicRequest',
  //   value: 'microscopicRequest',
  //   alias: 'microscopic',
  //   disabled: false,
  //   excludeFields: ['remark', 'uploadFiles'],
  // },
];

// 检测类型表单 以下字段顺序请勿随意变更！🈲🈲🈲🈲，如有需求请联系 coderLi
export const DETECITON_TYPE_FORM = [
  {
    feild: 'inspectionReportRequest',
    ai: 'inspectionReportRequest',
    aiLabel: '',
    label: '三方检疫',
    excludeFields: ['uploadFiles', 'submitDate'],
  },
  {
    feild: 'healthRecordRequest',
    ai: 'healthRecordRequest',
    label: '健康情况',
    excludeFields: ['uploadFiles', 'submitDate'],
  },
  {
    feild: 'growthSituationRequest',
    ai: 'growthSituationRequest',
    label: '生长情况',
    excludeFields: ['uploadFiles', 'submitDate'],
  },
  // {
  //   feild: 'microscopicRequest',
  //   ai: 'microscopicRequest',
  //   label: '镜检',
  //   excludeFields: ['uploadFiles'],
  // }
];

// 至少有一个必填项
export const HAS_MANDATORY_FORM = [
  {
    feild: 'waterRequest',
    name: '水质监测',
    excludeFields: ['uploadFiles', 'waterResult'],
  },
  {
    feild: 'environmentRecordRequest',
    name: '环控管理',
    excludeFields: ['uploadFiles'],
  },
  // {
  //   feild: 'medicationRequest',
  //   name: '动保记录',
  //   excludeFields: ['details', 'uploadFiles'],
  // },
  // {
  //   feild: 'aquaMedication',
  //   name: '动保记录',
  //   excludeFields: ['uploadFiles'],
  // },
];

// 是否为测试环境
export const IS_TEST = false;

// 是否有上报数据
export const DATA_FLAG = 'report-data-flag';
// 存储当前批次 系统 id code
export const SYSTEM_ID = 'report-ststem-id';
// 存储指定批次 系统的form表单
export const SYSTEM_BATCH_FORM_STORAGE = 'system-batch-form-storage';

export const token = null;
